export const INDICATOR_TYPE_PROCESS = 'Proceso'
export const INDICATOR_TYPE_RESULTS = 'Resultados'
export const INDICATOR_TYPE_STRUCTURAL = 'Estructurales'
export const UPLOAD = '/uploads/'
